/* OrthoClear theme — interactivity
   No dependencies. Progressive enhancement over server-rendered Liquid. */
(function () {
  'use strict';

  /* ---- mobile nav toggle ------------------------------------------------ */
  function initNav() {
    document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = btn.closest('.oc-nav');
        if (nav) {
          var open = nav.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });
    });
  }

  /* ---- mega menu (hover reveal on desktop via CSS; click toggle for mobile) */
  function initMegaMenu() {
    var menus = document.querySelectorAll('[data-megamenu]');
    if (!menus.length) return;
    function closeAll(except) {
      menus.forEach(function (mm) {
        if (mm === except) return;
        mm.classList.remove('is-open');
        var b = mm.querySelector('[data-mega-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    menus.forEach(function (mm) {
      var btn = mm.querySelector('[data-mega-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = mm.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) closeAll(mm);
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-megamenu]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* ---- pricing / billing toggle (monthly vs full) ----------------------- */
  function initBillingToggle() {
    document.querySelectorAll('[data-billing-toggle]').forEach(function (root) {
      var buttons = root.querySelectorAll('[data-billing]');
      function apply(mode) {
        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-billing') === mode);
        });
        root.querySelectorAll('[data-price-monthly]').forEach(function (el) {
          el.style.display = mode === 'monthly' ? '' : 'none';
        });
        root.querySelectorAll('[data-price-full]').forEach(function (el) {
          el.style.display = mode === 'full' ? '' : 'none';
        });
      }
      buttons.forEach(function (b) {
        b.addEventListener('click', function () { apply(b.getAttribute('data-billing')); });
      });
      apply(root.getAttribute('data-default') || 'monthly');
    });
  }

  /* ---- autoplay muted looping videos (React-safe on real DOM) ----------- */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-autoplay]');
    function tryPlay() {
      vids.forEach(function (v) {
        v.muted = true; v.loop = true; v.playsInline = true;
        if (!v.paused) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }
    tryPlay();
    // iOS Low Power Mode blocks autoplay but allows play after a user gesture;
    // retry once on the first interaction so the videos still come alive.
    ['touchstart', 'scroll', 'click'].forEach(function (ev) {
      window.addEventListener(ev, tryPlay, { once: true, passive: true });
    });
  }

  /* ---- scroll reveal ---------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.oc-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        // Subtle stagger: siblings that reveal together cascade in.
        var parent = el.parentElement;
        if (parent) {
          var sibs = Array.prototype.filter.call(parent.children, function (c) {
            return c.classList && c.classList.contains('oc-reveal');
          });
          var idx = sibs.indexOf(el);
          if (idx > 0) el.style.transitionDelay = Math.min(idx * 70, 280) + 'ms';
        }
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- FAQ / accordion (optional expand) -------------------------------- */
  function initAccordion() {
    document.querySelectorAll('[data-accordion] [data-acc-q]').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('[data-acc-item]');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  /* ---- quiz ------------------------------------------------------------- */
  function initQuiz() {
    var quiz = document.querySelector('[data-quiz]');
    if (!quiz) return;

    var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-quiz-step]'));
    var resultEl = quiz.querySelector('[data-quiz-result]');
    var bar = quiz.querySelector('[data-quiz-bar]');
    var counter = quiz.querySelector('[data-quiz-counter]');
    var backBtn = quiz.querySelector('[data-quiz-back]');
    var answers = {};
    var current = 0;

    function render() {
      steps.forEach(function (s, i) { s.hidden = i !== current; });
      if (resultEl) resultEl.hidden = true;
      var pct = Math.round((current / steps.length) * 100);
      if (bar) bar.style.width = pct + '%';
      if (counter) counter.textContent = (current + 1) + ' / ' + steps.length;
      if (backBtn) backBtn.style.visibility = current === 0 ? 'hidden' : 'visible';
    }

    function score() {
      // Mirrors the design's recommend() logic, mapped to GO/Flex/Pro.
      var sev = answers.severity;
      var hist = answers.history;
      if (hist === 'relapse' && (sev === 'slight' || sev === 'unsure')) return 'go';
      if (sev === 'significant') return 'pro';
      if (sev === 'moderate') return 'flex';
      return 'flex';
    }

    function finish() {
      var plan = score();
      quiz.setAttribute('data-quiz-plan', plan);
      steps.forEach(function (s) { s.hidden = true; });
      if (bar) bar.style.width = '100%';
      if (counter) counter.textContent = 'Done';
      if (backBtn) backBtn.style.visibility = 'hidden';
      if (resultEl) {
        resultEl.hidden = false;
        resultEl.querySelectorAll('[data-quiz-plancard]').forEach(function (c) {
          c.hidden = c.getAttribute('data-quiz-plancard') !== plan;
        });
        var minor = answers.age === 'no';
        var note = resultEl.querySelector('[data-quiz-minor]');
        if (note) note.hidden = !minor;
      }
    }

    quiz.querySelectorAll('[data-quiz-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var step = opt.closest('[data-quiz-step]');
        var key = step.getAttribute('data-quiz-key');
        answers[key] = opt.getAttribute('data-quiz-option');
        step.querySelectorAll('[data-quiz-option]').forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        if (current < steps.length - 1) { current++; render(); }
        else { finish(); }
      });
    });

    if (backBtn) backBtn.addEventListener('click', function () {
      if (current > 0) { current--; render(); }
    });

    var restart = quiz.querySelector('[data-quiz-restart]');
    if (restart) restart.addEventListener('click', function (e) {
      e.preventDefault(); answers = {}; current = 0; render();
    });

    /* ---- lead capture: Shopify contact form posts into a hidden iframe, so
       the email is sent, the page never navigates, and the thanks stays put -- */
    var leadForm = quiz.querySelector('[data-quiz-form]');
    if (leadForm) {
      leadForm.addEventListener('submit', function () {
        // (No preventDefault — the form submits into the hidden iframe.)
        var plan = quiz.getAttribute('data-quiz-plan') || '';
        var planField = leadForm.querySelector('[data-quiz-plan-field]');
        var bodyField = leadForm.querySelector('[data-quiz-body-field]');
        if (planField) planField.value = plan || 'not set';
        if (bodyField) bodyField.value = 'Smile quiz lead — recommended plan: ' + (plan || 'not set');
        try {
          var emailInput = leadForm.querySelector('input[name="contact[email]"]');
          if (window.tlq) tlq('track', 'Lead', { email: emailInput ? emailInput.value : '', leadSource: 'smile-quiz', recommendedPlan: plan || '' });
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'quiz_lead', recommended_plan: plan || '' });
        } catch (err) {}
        var btn = leadForm.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
        setTimeout(function () {
          var lead = quiz.querySelector('[data-quiz-lead]');
          var thanks = quiz.querySelector('[data-quiz-thanks]');
          if (lead) lead.hidden = true;
          if (thanks) thanks.hidden = false;
        }, 150);
      });
    }

    render();
  }

  /* ---- product variant radios → variant id ------------------------------ */
  function initProductOptions() {
    document.querySelectorAll('[data-product-options]').forEach(function (root) {
      var dataEl = root.querySelector('[data-variant-json]');
      var idInput = root.querySelector('[data-variant-id]');
      if (!dataEl || !idInput) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var form = root.closest('form');
      var submitBtn = form ? form.querySelector('[name="add"]') : null;
      var groups = root.querySelectorAll('.oc-vgroup');

      // Optional: live-update the big price from a variant-id → formatted-price map.
      var priceOut = document.querySelector('[data-oc-price]');
      var priceMap = null;
      var priceMapEl = root.querySelector('[data-variant-prices]') || document.querySelector('[data-variant-prices]');
      if (priceMapEl) { try { priceMap = JSON.parse(priceMapEl.textContent); } catch (e) {} }

      function selectedValues() {
        var vals = [];
        groups.forEach(function (g) {
          var checked = g.querySelector('input[type="radio"]:checked');
          vals.push(checked ? checked.value : null);
        });
        return vals;
      }

      function update(evt) {
        var sel = selectedValues();
        var match = variants.filter(function (v) {
          return sel.every(function (val, i) { return v['option' + (i + 1)] === val; });
        })[0];
        if (!match) return;
        idInput.value = match.id;
        if (submitBtn) {
          if (match.available) { submitBtn.removeAttribute('disabled'); }
          else { submitBtn.setAttribute('disabled', 'disabled'); }
        }
        if (priceMap && priceOut && priceMap[match.id]) priceOut.textContent = priceMap[match.id];
        // Reflect the selection in the address bar (user changes only, not the
        // initial load) so the URL can be copied as a pre-selected product link.
        if (evt && window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', match.id);
            history.replaceState(null, '', u);
          } catch (e) {}
        }
      }

      root.querySelectorAll('.oc-vopt input[type="radio"]').forEach(function (r) {
        r.addEventListener('change', update);
      });
      update();
    });
  }

  /* ---- image slider (scroll-snap + arrows + dots) ----------------------- */
  function initSlider() {
    document.querySelectorAll('[data-slider]').forEach(function (s) {
      var track = s.querySelector('[data-slider-track]');
      if (!track || track.children.length < 2) return;
      var count = track.children.length;
      var dots = s.querySelectorAll('[data-slider-dot]');
      var prev = s.querySelector('[data-slider-prev]');
      var next = s.querySelector('[data-slider-next]');

      function current() { return Math.round(track.scrollLeft / track.clientWidth); }
      function goTo(i) {
        i = Math.max(0, Math.min(count - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

      var raf;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var c = current();
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
        });
      });

      // Optional auto-advance (same feel as the hero slider): opt-in via
      // data-slider-autoplay. Loops, pauses on hover/focus/touch and when the
      // tab is hidden, and stays off under reduced-motion.
      if (s.hasAttribute('data-slider-autoplay') &&
          !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
        var interval = parseInt(s.getAttribute('data-slider-interval'), 10) || 4500;
        var timer = null;
        var play = function () { if (timer) return; timer = setInterval(function () { goTo((current() + 1) % count); }, interval); };
        var pause = function () { if (timer) { clearInterval(timer); timer = null; } };
        var bump = function () { pause(); play(); };
        if (prev) prev.addEventListener('click', bump);
        if (next) next.addEventListener('click', bump);
        dots.forEach(function (d) { d.addEventListener('click', bump); });
        s.addEventListener('mouseenter', pause);
        s.addEventListener('mouseleave', play);
        s.addEventListener('focusin', pause);
        s.addEventListener('focusout', play);
        s.addEventListener('touchstart', pause, { passive: true });
        document.addEventListener('visibilitychange', function () { document.hidden ? pause() : play(); });
        play();
      }
    });
  }

  /* ---- hero image slider (auto-rotating, translateX) -------------------- */
  function initHeroSlider() {
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    document.querySelectorAll('[data-hero-slider]').forEach(function (s) {
      if (s._ocHeroInit) return; s._ocHeroInit = true;
      var track = s.querySelector('[data-hs-track]');
      if (!track || track.children.length < 2) return;
      var count = track.children.length;
      var dots = Array.prototype.slice.call(s.querySelectorAll('[data-hs-dot]'));
      var interval = parseInt(s.getAttribute('data-hs-interval'), 10) || 4500;
      var i = 0, timer = null;

      function go(n) {
        i = (n + count) % count;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }
      function start() { if (reduce || timer) return; timer = setInterval(function () { go(i + 1); }, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); stop(); start(); }); });
      s.addEventListener('mouseenter', stop);
      s.addEventListener('mouseleave', start);
      s.addEventListener('focusin', stop);
      s.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

      go(0); start();
    });
  }

  /* ---- custom language switcher (Weglot API) ---------------------------- */
  function initLangSwitch() {
    var mount = document.querySelector('[data-oc-lang]');
    if (!mount) return;

    function collectCodes() {
      var codes = [];
      var W = window.Weglot;
      try {
        if (typeof W.getAvailableLanguages === 'function') {
          codes = (W.getAvailableLanguages() || []).slice();
        }
      } catch (e) {}
      var o = (W && W.options) || {};
      if (!codes.length) {
        (o.languages || o.destination_languages || []).forEach(function (l) {
          var c = (l && (l.language_to || l.custom_code)) || l;
          if (c) codes.push(c);
        });
      }
      if (o.language_from && codes.indexOf(o.language_from) === -1) codes.unshift(o.language_from);
      return codes.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
    }

    function build() {
      var W = window.Weglot;
      var codes = collectCodes();
      if (!codes.length) return; // leave Weglot's own switcher as fallback
      var current;
      try { current = W.getCurrentLang(); } catch (e) {}
      current = current || codes[0];

      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'oc-langbtn'; btn.setAttribute('aria-haspopup', 'true');
      btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"></circle><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"></path></svg>' +
        '<span class="oc-langbtn__code">' + current.toUpperCase() + '</span><span class="oc-langbtn__caret">▾</span>';

      var list = document.createElement('div'); list.className = 'oc-langlist'; list.hidden = true;
      codes.forEach(function (c) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'oc-langlist__item' + (c === current ? ' is-active' : '');
        item.textContent = c.toUpperCase();
        item.setAttribute('data-lang', c);
        item.addEventListener('click', function () {
          try { W.switchTo(c); } catch (e) {}
          list.hidden = true;
        });
        list.appendChild(item);
      });

      btn.addEventListener('click', function (e) { e.stopPropagation(); list.hidden = !list.hidden; });
      document.addEventListener('click', function () { list.hidden = true; });

      mount.innerHTML = '';
      mount.appendChild(btn);
      mount.appendChild(list);

      if (W.on) W.on('languageChanged', function () {
        var cur; try { cur = W.getCurrentLang(); } catch (e) {}
        cur = cur || current;
        var codeEl = mount.querySelector('.oc-langbtn__code');
        if (codeEl) codeEl.textContent = cur.toUpperCase();
        mount.querySelectorAll('.oc-langlist__item').forEach(function (i) {
          i.classList.toggle('is-active', i.getAttribute('data-lang') === cur);
        });
      });
    }

    function whenReady() {
      var W = window.Weglot;
      if (W && W.initialized) { build(); return true; }
      if (W && W.on) { W.on('initialized', build); return true; }
      return false;
    }
    if (!whenReady()) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (whenReady() || tries > 40) clearInterval(iv);
      }, 150);
    }
  }

  /* ---- subscription button label (JUO one-time vs subscription) --------- */
  function initSubscriptionButton() {
    var widget = document.getElementById('juo-subscription-widget');
    if (!widget) return;
    var form = widget.closest('form');
    var btn = form && form.querySelector('button[name="add"]');
    if (!btn) return;
    var subLabel = btn.getAttribute('data-sub-label') || btn.textContent.trim();
    var oneLabel = btn.getAttribute('data-onetime-label') || 'Add to cart';

    function isSubscription() {
      // The subscription option is JUO's .j-subscription; check its radio/state.
      var sub = widget.querySelector('.j-option.j-subscription');
      if (sub) {
        var input = sub.querySelector('input[type="radio"],input[type="checkbox"]');
        if (input) return input.checked;
        if (sub.hasAttribute('aria-checked')) return sub.getAttribute('aria-checked') === 'true';
        if (/\bj-(selected|active)\b/.test(sub.className)) return true;
      }
      // Fallback: a non-empty selling_plan means a subscription is chosen.
      var sp = form.querySelector('[name="selling_plan"]');
      return !!(sp && sp.value);
    }

    function selectedOption() {
      var sel;
      try { sel = widget.querySelector('.j-option:has(input:checked)'); } catch (e) {}
      return sel
        || widget.querySelector('.j-option.j-selected')
        || widget.querySelector('.j-option.j-active')
        || widget.querySelector('.j-option[aria-checked="true"]');
    }

    var priceEl = document.querySelector('[data-oc-price]');
    var suffixEl = document.querySelector('[data-oc-price-suffix]');
    var serverPrice = priceEl ? priceEl.textContent : '';

    // The price now reflects the exact selected option, so "from" no longer applies here.
    var prefixEl = document.querySelector('[data-oc-price-prefix]');
    if (prefixEl) prefixEl.style.display = 'none';

    function syncPrice() {
      if (!priceEl) return;
      var opt = selectedOption();
      // Mirror the selected option's effective price (last € amount in its header row).
      if (opt) {
        var header = opt.querySelector('.j-label') || opt;
        var m = (header.textContent || '').match(/€\s?\d[\d.,]*/g);
        var raw = (m && m.length) ? m[m.length - 1] : serverPrice;
        // Drop trailing ",00" / ".00" decimals (keep them if there are real cents).
        priceEl.textContent = raw.replace(/[.,]0{2}$/, '');
      }
      // "/ delivery" only makes sense for the subscription option.
      if (suffixEl) suffixEl.style.display = isSubscription() ? '' : 'none';
    }

    function update() {
      btn.textContent = isSubscription() ? subLabel : oneLabel;
      syncPrice();
    }

    // Debounced re-sync — used for interactions AND for JUO's async hydration.
    var t;
    function schedule() { clearTimeout(t); t = setTimeout(update, 80); }

    ['change', 'click'].forEach(function (ev) { widget.addEventListener(ev, schedule); });

    // JUO renders/selects its default option after our script runs, so watch for it.
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(widget, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['class', 'aria-checked', 'value', 'style', 'checked']
      });
    }
    // Safety-net retries in case the widget hydrates before the observer attaches.
    [200, 500, 1000, 2000].forEach(function (ms) { setTimeout(update, ms); });
    update();
  }

  /* ---- stacking rows ---------------------------------------------------- */
  /* Rich-split rows with "Stack on scroll" enabled pin and stack as you scroll.
     Each row is its own Shopify section, so their sticky context is <main> (the
     whole page) — which would keep the last row pinned over everything below.
     To get the timeline's clean release, we move the rows into ONE wrapper so
     sticky resolves against it and releases after the last card. */
  function initStackingRows() {
    window.__ocStacking = 'v2:init'; // presence in console confirms this theme.js is live
    document.body.style.overflowX = 'clip'; // clip (not hidden) so sticky isn't broken
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var desktop = window.matchMedia('(min-width:769px)').matches && !reduce;

    // Collect target sections: prefer the data-oc-stack marker, else eyebrow text.
    var secs = [];
    function add(sec, idx) { if (sec && secs.indexOf(sec) === -1) { sec._ocIdx = idx; secs.push(sec); } }
    var marked = document.querySelectorAll('[data-oc-stack]');
    if (marked.length) {
      marked.forEach(function (el) { add(el.closest('.shopify-section'), parseInt(el.getAttribute('data-oc-stack'), 10) || 0); });
    } else {
      var map = { 'keep it stable': 0, 'how it works': 1, 'removable vs. fixed': 2 };
      document.querySelectorAll('.oc-eyebrow').forEach(function (e) {
        var k = e.textContent.trim().toLowerCase();
        if (Object.prototype.hasOwnProperty.call(map, k)) add(e.closest('.shopify-section'), map[k]);
      });
    }
    window.__ocStacking = 'v2 rows=' + secs.length;
    if (!secs.length) return;

    // Order by document position and move them all into one shared wrapper so
    // sticky both stacks AND releases cleanly after the last card.
    secs.sort(function (a, b) { return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1; });
    var wrap = document.getElementById('oc-stack-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'oc-stack-wrap';
      wrap.className = 'oc-stack-wrap';
      secs[0].parentNode.insertBefore(wrap, secs[0]);
    }
    secs.forEach(function (s, i) {
      if (s.parentNode !== wrap) wrap.appendChild(s);
      if (desktop) {
        s.style.position = 'sticky';
        // Same top for every row so each card fully covers the previous one
        // (no peeking sliver) as it scrolls up and pins.
        s.style.top = '88px';
        s.classList.add('oc-rs-sticky');
      } else {
        s.style.position = '';
        s.style.top = '';
        s.classList.remove('oc-rs-sticky');
      }
    });
  }

  /* ---- scanner hero: scale-in reveal + scroll-linked 3D turn ------------ */
  function initScannerHero() {
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    document.querySelectorAll('[data-shero]').forEach(function (sec) {
      // Reveal on enter
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.disconnect(); } });
        }, { threshold: 0.15 });
        io.observe(sec);
      } else { sec.classList.add('is-in'); }

      // Gentle 3D turntable that tracks scroll position
      var media = sec.querySelector('[data-shero-media]');
      if (!media || reduce) return;
      var ticking = false;
      function update() {
        ticking = false;
        var rect = media.getBoundingClientRect();
        var vh = window.innerHeight || 1;
        var t = ((rect.top + rect.height / 2) - vh / 2) / vh; // -1 (above centre) → +1 (below)
        if (t > 1) t = 1; else if (t < -1) t = -1;
        var rotY = t * 34;                    // turn left→right as it passes centre
        var rotX = (1 - Math.abs(t)) * 8;     // forward tilt near centre
        var scale = 1 - Math.abs(t) * 0.06;   // subtly recede toward the edges
        media.style.transform = 'rotateX(' + rotX.toFixed(2) + 'deg) rotateY(' + rotY.toFixed(2) + 'deg) scale(' + scale.toFixed(3) + ')';
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }

  /* ---- interactive feature spotlight (scrollytelling + hotspots) -------- */
  function initSpotlight() {
    document.querySelectorAll('[data-spotlight]').forEach(function (sec) {
      var panels = Array.prototype.slice.call(sec.querySelectorAll('[data-spot-panel]'));
      var dots = Array.prototype.slice.call(sec.querySelectorAll('[data-spot-dot]'));
      if (!panels.length) return;
      function setActive(i) {
        panels.forEach(function (p, pi) { p.classList.toggle('is-active', pi === i); });
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }
      dots.forEach(function (d, di) {
        d.addEventListener('click', function () {
          if (panels[di]) panels[di].scrollIntoView({ behavior: 'smooth', block: 'center' });
          setActive(di);
        });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { var i = panels.indexOf(e.target); if (i > -1) setActive(i); }
          });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        panels.forEach(function (p) { io.observe(p); });
      }
    });
  }

  function init() {
    initNav();
    initMegaMenu();
    initScannerHero();
    initSpotlight();
    initProductOptions();
    initSlider();
    initHeroSlider();
    initLangSwitch();
    initBillingToggle();
    initVideos();
    initReveal();
    initAccordion();
    initQuiz();
    initSubscriptionButton();
    initStackingRows();
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(initStackingRows, 150); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
